export const CHAT_BASE_URL = '/chat';
export const HELPCENTER_STARTED_MESSAGE = 'HELPCENTER_INIT_STARTED';
export const HOST_IS_READY_MESSAGE = 'HOST_IS_READY';
export const HELPCENTER_ASKS_FOR_SHUTDOWN = 'HELPCENTER_ASKS_FOR_SHUTDOWN';
